import { render, staticRenderFns } from "./setBook.vue?vue&type=template&id=3aaec825&scoped=true&"
import script from "./setBook.vue?vue&type=script&lang=js&"
export * from "./setBook.vue?vue&type=script&lang=js&"
import style0 from "./setBook.vue?vue&type=style&index=0&id=3aaec825&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./setBook.vue?vue&type=style&index=1&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaec825",
  null
  
)

export default component.exports